import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import BirthdayCelebration from '../BirthdayCelebration/BirthdayCelebration';
import { isTodayFounderBirthday } from '../BirthdayCelebration/BirthdayCelebration.jsx';
import './Home.css';

const Home = () => {
  const [showBirthdayCelebration, setShowBirthdayCelebration] = useState(false);
  const [birthdayFounder, setBirthdayFounder] = useState(null);
  
  // 检查今天是否是创始人生日
  useEffect(() => {
    // 使用导出的函数检查是否今天是创始人生日
    const birthdayCheck = isTodayFounderBirthday();
    
    console.log("Home组件 - 生日检查结果:", birthdayCheck);
    
    if (birthdayCheck.isToday) {
      // 如果今天是创始人生日，保存这个信息
      setBirthdayFounder(birthdayCheck.founder);
    } else {
      // 今天不是任何创始人的生日
      setBirthdayFounder(null);
    }
  }, []);
  
  const handleBirthdayClick = () => {
    setShowBirthdayCelebration(true);
    
    // 不再设置自动关闭的定时器，让用户手动关闭
  };

  // 模拟海龟汤数据
  const puzzleItems = [
    {
      id: 1,
      title: '消失的旅客',
      description: '一列火车穿过隧道，出来时少了一名乘客...',
      creator: '拍拍',
      date: '2025-02-28',
      cover: 'https://source.unsplash.com/random/600x600?mystery',
      difficulty: '中等',
      views: '342',
      comments: '4',
      favorites: '128'
    },
    {
      id: 2,
      title: '奇怪的遗嘱',
      description: '富翁留下的遗嘱中只有一句话：向北走十步...',
      creator: '拍拍',
      date: '2025-02-25',
      cover: 'https://source.unsplash.com/random/600x600?puzzle',
      difficulty: '困难',
      views: '287',
      comments: '4',
      favorites: '65'
    },
    {
      id: 3,
      title: '雨夜里的陌生人',
      description: '暴雨中，一个陌生人敲开了独居老人的门...',
      creator: '拍拍',
      date: '2025-04-21',
      cover: 'https://source.unsplash.com/random/600x600?night',
      difficulty: '简单',
      views: '332',
      comments: '4',
      favorites: '89'
    },
    {
      id: 4,
      title: '空中楼阁',
      description: '他看到了一座悬浮在空中的城堡，但没人相信他...',
      creator: '拍拍',
      date: '2025-04-01',
      cover: 'https://source.unsplash.com/random/600x600?fantasy',
      difficulty: '中等',
      views: '245',
      comments: '4',
      favorites: '62'
    },
    {
      id: 5,
      title: '镜中世界',
      description: '他发现镜子里的自己有时会做出不同的动作...',
      creator: '拍拍',
      date: '2025-04-13',
      cover: 'https://source.unsplash.com/random/600x600?mirror',
      difficulty: '困难',
      views: '310',
      comments: '4',
      favorites: '85'
    },
    {
      id: 6,
      title: '午夜来电',
      description: '每天午夜，她都会收到一通未知号码的电话...',
      creator: '拍拍',
      date: '2025-03-21',
      cover: 'https://source.unsplash.com/random/600x600?phone',
      difficulty: '中等',
      views: '224',
      comments: '4',
      favorites: '58'
    },
    {
      id: 7,
      title: '沉默的窃贼',
      description: '银行被盗，但监控录像显示没有人进出...',
      creator: '拍拍',
      date: '2025-01-29',
      cover: 'https://source.unsplash.com/random/600x600?detective',
      difficulty: '困难',
      views: '356',
      comments: '4',
      favorites: '92'
    },
    {
      id: 8,
      title: '诡异的录音',
      description: '科学家在无人岛上录到了人声...',
      creator: '拍拍',
      date: '2025-01-13',
      cover: 'https://source.unsplash.com/random/600x600?horror',
      difficulty: '中等',
      views: '302',
      comments: '4',
      favorites: '76'
    }
  ];

  // 社区优秀创作者数据
  const communityStars = [
    {
      id: 1,
      name: 'Ethan Zyc',
      avatar: '/images/turtle-avatar.png',
    },
    {
      id: 2,
      name: '赫哥赫哥',
      avatar: '/images/turtle-avatar.png',
    },
    {
      id: 3,
      name: '庆杰',
      avatar: '/images/turtle-avatar.png',
    },
    {
      id: 4,
      name: '拍拍',
      avatar: '/images/turtle-avatar.png',
    },
    {
      id: 5,
      name: '孙昱睿',
      avatar: '/images/turtle-avatar.png',
    }
  ];

  // 自定义Link组件，在新标签页中打开
  const ExternalLink = ({ to, className, children }) => (
    <a href={to} target="_blank" rel="noopener noreferrer" className={className}>
      {children}
    </a>
  );

  return (
    <div className="elegant-app">
      <Header />
      
      <div className="header-banner-connector"></div>
      
      {showBirthdayCelebration && (
        <BirthdayCelebration 
          forceCelebrate={false} 
          founderName={birthdayFounder?.name} 
          onClose={() => setShowBirthdayCelebration(false)}
        />
      )}
      
      <main className="elegant-main elegant-main-no-gap">
        <section className="elegant-banner">
          {birthdayFounder && (
            <button 
              className="birthday-button" 
              onClick={handleBirthdayClick}
              title={`今天是${birthdayFounder.name}的生日！`}
            >
              <svg className="birthday-button-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="cake-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#ffdf5e" />
                    <stop offset="100%" stopColor="#ffb347" />
                  </linearGradient>
                </defs>
                <path d="M12,6C13.11,6 14,5.1 14,4C14,3.62 13.9,3.27 13.71,2.97L12,0L10.29,2.97C10.1,3.27 10,3.62 10,4C10,5.1 10.9,6 12,6M16.6,16L15.53,14.92L14.45,16C13.15,17.29 10.87,17.3 9.56,16L8.5,14.92L7.4,16C6.75,16.64 5.88,17 4.96,17C4.23,17 3.56,16.77 3,16.39V21C3,21.55 3.45,22 4,22H20C20.55,22 21,21.55 21,21V16.39C20.44,16.77 19.77,17 19.04,17C18.12,17 17.25,16.64 16.6,16M18,9H13V7H11V9H6C4.34,9 3,10.34 3,12V13.54C3,14.62 3.88,15.5 4.96,15.5C5.5,15.5 6,15.3 6.34,14.93L8.5,12.8L10.61,14.93C11.35,15.67 12.64,15.67 13.38,14.93L15.5,12.8L17.65,14.93C18,15.3 18.5,15.5 19.03,15.5C20.11,15.5 21,14.62 21,13.54V12C21,10.34 19.66,9 18,9Z"/>
              </svg>
            </button>
          )}
          <div className="elegant-banner-content">
            <h1 className="elegant-banner-title">探索 海龟汤 的奇妙世界</h1>
            <p className="elegant-banner-subtitle">在 HugTub 上体验逻辑推理与脑力激荡的乐趣</p>
            <div className="elegant-banner-buttons">
              <ExternalLink to="/create" className="elegant-banner-button">创作海龟汤</ExternalLink>
              <ExternalLink to="/discover" className="elegant-banner-button elegant-banner-button-secondary">发现海龟汤</ExternalLink>
            </div>
          </div>
        </section>
        
        <section className="elegant-section">
          <div className="featured-puzzles">
            <div className="featured-puzzles-header">
              <h2>精选作品</h2>
              <ExternalLink to="/discover" className="view-more-link">
                查看更多作品 <i className="fas fa-chevron-right"></i>
              </ExternalLink>
            </div>
            <div className="puzzle-grid">
              {puzzleItems.map(puzzle => (
                <ExternalLink 
                  to={`/puzzle/${puzzle.id}`}
                  key={puzzle.id} 
                  className="puzzle-card"
                >
                  <div className="puzzle-image">
                    <img 
                      src={puzzle.cover || '/images/default.png'} 
                      alt={puzzle.title} 
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/images/default.png';
                      }}
                    />
                  </div>
                  <div className="puzzle-info">
                    <h3>{puzzle.title}</h3>
                    <div className="puzzle-meta-author">
                      <span className="puzzle-creator">
                        {puzzle.creator || puzzle.author.username || "匿名用户"}
                      </span>
                      <span className="puzzle-likes">
                        <i className="fas fa-heart"></i> {puzzle.favorites || puzzle.likes || 0}
                      </span>
                    </div>
                  </div>
                </ExternalLink>
              ))}
            </div>
          </div>
        </section>
        
        <section className="elegant-section">
          <div className="featured-puzzles-header">
            <h2>海龟汤分类</h2>
            <ExternalLink to="/discover" className="view-more-link">
              了解更多 <i className="fas fa-chevron-right"></i>
            </ExternalLink>
          </div>
          
          <div className="elegant-categories">
            <ExternalLink to="/discover?category=推理" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-search"></i>
              </div>
              <span>推理</span>
            </ExternalLink>
            <ExternalLink to="/discover?category=悬疑" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-question-circle"></i>
              </div>
              <span>悬疑</span>
            </ExternalLink>
            <ExternalLink to="/discover?category=恐怖" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-ghost"></i>
              </div>
              <span>恐怖</span>
            </ExternalLink>
            <ExternalLink to="/discover?category=奇幻" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-magic"></i>
              </div>
              <span>奇幻</span>
            </ExternalLink>
            <ExternalLink to="/discover?category=科幻" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <span>科幻</span>
            </ExternalLink>
            <ExternalLink to="/discover?category=冒险" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-compass"></i>
              </div>
              <span>冒险</span>
            </ExternalLink>
            <ExternalLink to="/discover?category=生活" className="elegant-category">
              <div className="elegant-category-icon">
                <i className="fas fa-home"></i>
              </div>
              <span>生活</span>
            </ExternalLink>
          </div>
        </section>
        
        <section className="elegant-section">
          <div className="elegant-popular-topics">
            {/* ... existing code for popular topics ... */}
          </div>
        </section>
        
        {/* 社区星推荐部分 */}
        <section className="elegant-section community-creators-section">
          <div className="community-creators">
            <div className="featured-puzzles-header">
              <h2>社区星推荐</h2>
              <ExternalLink to="/creators" className="view-more-link">
                往期社区星 <i className="fas fa-chevron-right"></i>
              </ExternalLink>
            </div>
            <div className="community-creators-grid">
              {communityStars.map(creator => (
                <a 
                  key={creator.id} 
                  className="community-creator-card"
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="community-creator-avatar">
                    <img 
                      src="/images/profile.png" 
                      alt={creator.name} 
                    />
                  </div>
                  <div className="community-creator-info">
                    <h3>{creator.name}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Home; 